
const firebaseConfig = {
  apiKey: "AIzaSyCFuZt4SLKJD_kWtbFFUR65C2TIKpGRF68",
  authDomain: "we-hire-39c1f.firebaseapp.com",
  projectId: "we-hire-39c1f",
  storageBucket: "we-hire-39c1f.appspot.com",
  messagingSenderId: "781600916540",
  appId: "1:781600916540:web:0dc01611c60d4fe6ad6f39"

  // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_FIREBASE_APP_ID
  };

  export default firebaseConfig